<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<p class="ct" id="toc_marker-3"><a id="Contents-A">Contents</a></p><a id="Contents-A">
</a></div><a id="Contents-A">
</a><div><a id="Contents-A">
<p class="ct"></p>
</a><p class="Contents-Entry"><a id="Contents-A"></a><a href="#/Resorting_to_Murder#toc_marker-1">Resorting to Murder</a></p>
<p class="Contents-Entry"><a href="#/Resorting_to_Murder1#toc_marker-2">Copyright</a></p>
<p class="Contents-Entry"><a href="#/#toc_marker-3">Contents</a></p>
<p class="Contents-Entry"><a href="#/Resorting_to_Murder3#toc_marker-4">Introduction</a></p>
<p class="Contents-Entry"><a href="#/Resorting_to_Murder4#toc_marker-5">The Adventure of the Devil’s Foot</a></p>
<p class="Contents-Entry"><span href="#/Resorting_to_Murder5#toc_marker-6" title="Link target outside of Sample">A Schoolmaster Abroad</span></p>
<p class="Contents-Entry"><span href="#/Resorting_to_Murder6#toc_marker-7" title="Link target outside of Sample">Murder!</span></p>
<p class="Contents-Entry"><span href="#/Resorting_to_Murder7#toc_marker-8" title="Link target outside of Sample">The Murder on the Golf Links</span></p>
<p class="Contents-Entry"><span href="#/Resorting_to_Murder8#toc_marker-9" title="Link target outside of Sample">The Finger of Stone</span></p>
<p class="Contents-Entry"><span href="#/Resorting_to_Murder9#toc_marker-10" title="Link target outside of Sample">The Vanishing of Mrs Fraser</span></p>
<p class="Contents-Entry"><span href="#/Resorting_to_Murder10#toc_marker-11" title="Link target outside of Sample">A Mystery of the Sand-Hills</span></p>
<p class="Contents-Entry"><span href="#/Resorting_to_Murder11#toc_marker-12" title="Link target outside of Sample">The Hazel Ice</span></p>
<p class="Contents-Entry"><span href="#/Resorting_to_Murder12#toc_marker-13" title="Link target outside of Sample">Razor Edge</span></p>
<p class="Contents-Entry"><span href="#/Resorting_to_Murder13#toc_marker-14" title="Link target outside of Sample">Holiday Task</span></p>
<p class="Contents-Entry"><span href="#/Resorting_to_Murder14#toc_marker-15" title="Link target outside of Sample">A Posteriori</span></p>
<p class="Contents-Entry"><span href="#/Resorting_to_Murder15#toc_marker-16" title="Link target outside of Sample">Where is Mr Manetot?</span></p>
<p class="Contents-Entry"><span href="#/Resorting_to_Murder16#toc_marker-17" title="Link target outside of Sample">The House of Screams</span></p>
<p class="Contents-Entry"><span href="#/Resorting_to_Murder17#toc_marker-18" title="Link target outside of Sample">Cousin Once Removed</span></p>
<p class="Contents-Entry"><span href="#/Resorting_to_Murder18#toc_marker-19" title="Link target outside of Sample">More from this Author</span></p>
<p class="Contents-Entry"><span href="#/Resorting_to_Murder19#toc_marker-20" title="Link target outside of Sample">Contact Us</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Resorting_to_Murder2.vue?2ed595a3